import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fad7f1e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-up-right-from-square" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-up-from-bracket" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareDialog = _resolveComponent("ShareDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.webShareApiSupported)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "share-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shareViaWebShare(false)))
        }, _hoisted_2))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "share-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openShareDialog && _ctx.openShareDialog(...args)))
        }, _hoisted_4)),
    _withDirectives(_createVNode(_component_ShareDialog, {
      onOnCloseWebShareModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openShareDialog(false)))
    }, null, 512), [
      [_vShow, _ctx.showShareDialog]
    ])
  ], 64))
}